import { render, staticRenderFns } from "./pagec.vue?vue&type=template&id=df93faf6&scoped=true"
import script from "./pagec.vue?vue&type=script&lang=js"
export * from "./pagec.vue?vue&type=script&lang=js"
import style0 from "./pagec.vue?vue&type=style&index=0&id=df93faf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df93faf6",
  null
  
)

export default component.exports